import React, { ReactElement } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  createOverseaWarehouseHandler,
  selectOverseaWarehouseModalLoading,
  setCreateOverseaWarehouseModal
} from '../../../../redux/overseaWarehouseSlice';

const { Option } = Select;

const CreateOverseaWarehouseModal = (): ReactElement => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const loading = useSelector(selectOverseaWarehouseModalLoading);
  const [selectedCountry, setSelectedCountry] = React.useState<string>('CN');

  const okClickedHander = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        const data = {
          ...values,
          country: selectedCountry
        };
        dispatch(createOverseaWarehouseHandler(data));
        dispatch(setCreateOverseaWarehouseModal(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModalHandler = () => {
    dispatch(setCreateOverseaWarehouseModal(false));
  };

  const countryChangeHandler = (value: string) => {
    setSelectedCountry(value);
  };

  return (
    <Modal
      width={600}
      bodyStyle={{
        minHeight: '300px',
        maxHeight: '1000px',
        overflowY: 'auto',
        margin: '10px 50px'
      }}
      visible
      centered
      closable={false}
      title="Create Oversea Warehouse"
      onOk={okClickedHander}
      onCancel={closeModalHandler}
      okButtonProps={{
        loading
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="客户名称"
          name="name"
          rules={[{ required: true, message: '客户名称不能为空!' }]}
        >
          <Input placeholder="客户名称" />
        </Form.Item>
        <Form.Item
          label="用户代码"
          name="code"
          rules={[{ required: true, message: '用户代码不能为空' }]}
        >
          <Input placeholder="用户代码" />
        </Form.Item>
        <Form.Item label="公司名称" name="company">
          <Input placeholder="公司名称" />
        </Form.Item>
        <Form.Item label="Phone" name="phone">
          <Input placeholder="phone" />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label="Address1"
          name="address1"
          rules={[{ required: true, message: 'Please input address1!' }]}
        >
          <Input placeholder="Address1" />
        </Form.Item>
        <Form.Item label="Address2" name="address2">
          <Input placeholder="Address2" />
        </Form.Item>
        <Form.Item
          label="City"
          name="city"
          rules={[{ required: true, message: 'Please input warehouse city!' }]}
        >
          <Input placeholder="City" />
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: 'Please input warehouse state!' }]}
        >
          <Input placeholder="State" />
        </Form.Item>
        <Form.Item
          label="Country"
          name="country"
          rules={[{ required: true, message: 'Please input warehouse country!' }]}
        >
          <Select placeholder="Country" optionLabelProp="label" onChange={countryChangeHandler}>
            <Option key="CN" value="CN" label="China">
              <div className="demo-option-label-item">
                <span role="img" aria-label="China">
                  🇨🇳
                </span>
                China (中国)
              </div>
            </Option>
            <Option key="US" value="US" label="United States">
              <div className="demo-option-label-item">
                <span role="img" aria-label="United States">
                  🇺🇸
                </span>
                United States (美国)
              </div>
            </Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Zip"
          name="zip"
          rules={[{ required: true, message: 'Please input warehouse zip!' }]}
        >
          <Input placeholder="Zip" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateOverseaWarehouseModal;
